import mutations from "./mutations";
import actions from "./actions";

const state = {
  incomingShipments: [],
  dockedShipments: [],
  departureShipments: [],
  allPortShipments: [],
  portStatistics: {},
  dispatchByTruckShippingRequests: [],
  dispatchByShipShippingRequests: [],
  portSearchQueryResult: []
};

const getters = {
  incomingShippingRequests: state => {
    let result = state.incomingShipments.map(incomingShipment => ({
      id: incomingShipment.id,
      ref_no: incomingShipment.reference_number,
      ship_name: incomingShipment.ship_name,
      shipper_name: incomingShipment.shipper_name,
      dg_total: incomingShipment.dangerousGoods.length,
      date_of_arrival: incomingShipment.date_of_arrival,
      voyage_number: incomingShipment.voyage_number,
      port_status: incomingShipment.port_status,
      updatePortStatus: true
    }));
    return result;
  },

  dockedShippingRequests: state => {
    let result = state.dockedShipments.map(dockedShipment => ({
      id: dockedShipment.id,
      ref_no: dockedShipment.reference_number,
      ship_name: dockedShipment.ship_name,
      dg_total: dockedShipment.dangerousGoods.length,
      shipper_name: dockedShipment.shipper_name,
      date_of_departure: dockedShipment.date_of_departure,
      date_of_arrival: dockedShipment.date_of_arrival,
      voyage_number: dockedShipment.voyage_number,
      port_status: dockedShipment.port_status,
      updatePortStatus: true
    }));
    return result;
  },

  departureShippingRequests: state => {
    let result = state.departureShipments.map(departureShipment => ({
      id: departureShipment.id,
      ref_no: departureShipment.reference_number,
      dg_total: departureShipment.dangerousGoods.length,
      ship_name: departureShipment.ship_name,
      shipper_name: departureShipment.shipper_name,
      date_of_departure: departureShipment.date_of_departure,
      voyage_number: departureShipment.voyage_number,
      port_status: departureShipment.port_status,
      updatePortStatus: true
    }));
    return result;
  },

  getAllPortShippingRequests: state => {
    let result = state.allPortShipments.map(allPortShipment => ({
      id: allPortShipment.id,
      ref_no: allPortShipment.reference_number,
      ship_name: allPortShipment.ship_name,
      dg_total: allPortShipment.dangerousGoods.length,
      shipper_name: allPortShipment.shipper_name,
      date_of_departure: allPortShipment.date_of_departure,
      date_of_arrival: allPortShipment.date_of_arrival,
      voyage_number: allPortShipment.voyage_number,
      port_status: allPortShipment.port_status,
      updatePortStatus: true
    }));
    return result;
  },
  getPortSearchShippingRequests: state => {
    let result = state.portSearchQueryResult.map(shipment => ({
      id: shipment.id,
      ref_no: shipment.reference_number,
      ship_name: shipment.ship_name,
      dg_total: shipment.dangerousGoods.length,
      shipper_name: shipment.shipper_name,
      date_of_departure: shipment.date_of_departure,
      date_of_arrival: shipment.date_of_arrival,
      voyage_number: shipment.voyage_number,
      port_status: shipment.port_status,
      updatePortStatus: true
    }));
    return result;
  },

  getPortShippingRequestStatistics: state => {
    return state.portStatistics;
  },

  getCompletedShippingRequests: state => {
    let list = state.dispatchByTruckShippingRequests.concat(
      state.dispatchByShipShippingRequests
    );

    let result = list.map(shippingRequest => ({
      id: shippingRequest.id,
      ref_no: shippingRequest.reference_number,
      ship_name: shippingRequest.ship_name,
      dg_total: shippingRequest.dangerousGoods.length,
      shipper_name: shippingRequest.shipper_name,
      date_of_departure: shippingRequest.date_of_departure,
      voyage_number: shippingRequest.voyage_number,
      port_status: shippingRequest.port_status
    }));

    return result;
  },

  dataForToday: state => {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    let yyyy = today.getFullYear();

    let today_formated = yyyy + "-" + "0" + mm + "-" + dd;

    let list = state.portData.filter(
      item => item.date_of_arrival === today_formated
    );

    let result = list.map(todayActivities => ({
      id: todayActivities.id,
      ref_no: todayActivities.reference_number,
      ship_name: todayActivities.ship_name,
      date_of_arrival: todayActivities.date_of_arrival,
      voyage_number: todayActivities.voyage_number,
      port_status: todayActivities.port_status
    }));

    return result;
  },

  getShippingRequestByID(state) {
    return id => {
      let list = state.incomingShipments
        .concat(state.dockedShipments)
        .concat(state.departureShipments)
        .concat(state.allPortShipments)
        .concat(state.dispatchByShipShippingRequests)
        .concat(state.dispatchByTruckShippingRequests);
      let result = list.filter(shippingRequest => shippingRequest.id === id);
      return result;
    };
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
